$( document ).ready(function() {
  // Only activate for certain paths
  if((window.location.pathname === "/") || window.location.pathname === "/collections/our-varieties"){

    function initSearchAddress(){
      const input = document.getElementById("js-measurement-input");
      var options = {
        types: ['address'],
        componentRestrictions: {
          country: 'au'
        }
      };

      const autocomplete = new google.maps.places.Autocomplete(input,options);
      map_data.locateAddressMap = function (){
        map_data.place = autocomplete.getPlace();
        if (!map_data.place || !map_data.place.geometry || !map_data.place.geometry.location) {
          window.alert("No details available for: " + input.value );
          return false;
        }
        map_data.postcode = map_data.place.address_components.find(e => e.types.indexOf('postal_code') != -1).long_name
        return true;
      };
    }

    initSearchAddress();
  }
});